import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntModalComponent} from "./int-modal.component";


@NgModule({
  declarations: [
    IntModalComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntModalComponent
  ]
})
export class IntModalModule {}